import {DefaultPolicy} from "../../containers/authenticate/DefaultPolicy";
import * as PolicyEvents from "../../constants/policyEvents";
import localStorage from "../../components/shared/localStorage";

export function checkUserPermissions(policyEvent = PolicyEvents.VIEWONLY, policy) {
    const auth = localStorage.getAuthentication();
    policy = policy ? new policy : new DefaultPolicy(auth.role);

    return (policy.permit(policyEvent));
}